/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilityType } from './capabilityType';
import { CapabilityEligibleIntervalApiModel } from './capabilityEligibleIntervalApiModel';


export interface CapabilityDefaultApiModel { 
    code: string;
    category?: number | null;
    type: CapabilityType;
    name: string;
    specification: string;
    eligibleIntervals: Array<CapabilityEligibleIntervalApiModel>;
}
export namespace CapabilityDefaultApiModel {
}


